import React from "react";
import "../styles/AfterHeroSection.css";
import { Link } from "react-router-dom";
const AfterHeroSection = () => {
  return (
    <div className=" after-hero-section mt-0 p-5 mx-5 row ">
      <div className=" col-5 image-section ">
        <img
          src="/Assets/tagline section.webp"
          // src={require("../Assets/tagline section.webp")}
          alt="Hero"
          loading="lazy"
        />
      </div>
      <div className="text-section col-2 text-center"></div>
      <div className="text-section col-md-5">
        <span className="after-hero-badge">Fast Track Your Success</span>
        <h2 className="after-hero-title">Your Faster Route to Driving</h2>
        <p className="text-section-p-enhanced">
          See how <strong>Pass Swiftly</strong> can help you get behind the
          wheel with confidence. Our proven methods and expert instructors ensure you're test-ready in record time.
        </p>
        <div className="d-flex justify-content-center align-items-center mt-4">
          <Link to="/courses/beginner" style={{ textDecoration: "none" }}>
            <button className="button-primary-enhanced px-4 py-3">
              Explore Our Courses
              <span className="button-arrow-after"> →</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AfterHeroSection;
